"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CamOnIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "1", y: "4", width: "17", height: "16", rx: "2", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M18 8.58032C18 8.22147 18.1923 7.89012 18.5039 7.71208L22.7558 5.2824C23.7558 4.71098 25 5.43304 25 6.58477V17.4152C25 18.567 23.7558 19.289 22.7558 18.7176L18.5039 16.2879C18.1923 16.1099 18 15.7785 18 15.4197V8.58032Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "1", y: "5.33333", width: "22.6667", height: "21.3333", rx: "2.66667", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M23.6666 11.4404C23.6666 10.962 23.923 10.5202 24.3384 10.2828L30.0077 7.04321C31.341 6.28131 33 7.24405 33 8.77969V23.2203C33 24.7559 31.341 25.7187 30.0077 24.9568L24.3384 21.7172C23.923 21.4798 23.6666 21.038 23.6666 20.5596V11.4404Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0)] }), void 0));
};
var CamOnIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.CamOnIcon = CamOnIcon;
//# sourceMappingURL=CamOnIcon.js.map